var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35 35",
    width: "35px",
    height: "35px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface88955613"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.5 1.640625 C 8.75 1.640625 1.640625 8.75 1.640625 17.5 C 1.640625 26.25 8.75 33.359375 17.5 33.359375 C 26.25 33.359375 33.359375 26.25 33.359375 17.5 C 33.359375 8.75 26.25 1.640625 17.5 1.640625 Z M 17.5 3.28125 C 25.347656 3.28125 31.71875 9.652344 31.71875 17.5 C 31.71875 25.347656 25.347656 31.71875 17.5 31.71875 C 9.652344 31.71875 3.28125 25.347656 3.28125 17.5 C 3.28125 9.652344 9.652344 3.28125 17.5 3.28125 Z M 17.5 8.203125 C 16.140625 8.203125 15.039062 9.304688 15.039062 10.664062 C 15.039062 12.023438 16.140625 13.125 17.5 13.125 C 18.859375 13.125 19.960938 12.023438 19.960938 10.664062 C 19.960938 9.304688 18.859375 8.203125 17.5 8.203125 Z M 17.5 16.132812 C 16.132812 16.132812 15.039062 17.226562 15.039062 18.59375 L 15.039062 25.15625 C 15.039062 26.523438 16.132812 27.617188 17.5 27.617188 C 18.867188 27.617188 19.960938 26.523438 19.960938 25.15625 L 19.960938 18.59375 C 19.960938 17.226562 18.867188 16.132812 17.5 16.132812 Z M 17.5 16.132812 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.46d089a4c2c7daa153a919891da462ba.svg";
export { ForwardRef as ReactComponent };